import React from 'react';

import SharePageDropdown from '../../../../common/dropdown/SharePageDropdown';

import useDomainUrl from '../../../../../utils/hooks/useDomainUrl';

const ContentOptimizerShareDropdown = ({
    optimizerId,
    children,
    isShared,
    shareLink,
    onChangedSharedCallback,
}) => {
    const { getDomainUrl } = useDomainUrl();

    return (
        <SharePageDropdown
            optimizerId={optimizerId}
            shareLink={`${getDomainUrl(`share/optimizer/${shareLink || ''}`)}`}
            isShared={isShared}
            onChangedSharedCallback={onChangedSharedCallback}
        >
            {children}
        </SharePageDropdown>
    );
};

export default ContentOptimizerShareDropdown;
